export const tempIsNotImageTask = (base_product) => {
  return [3068, 5363, 4763, 4908, 4265, 4266, 3950].includes(base_product?.id);
};
